import { Notifications } from "@mui/icons-material";
import { IconButton, Stack, Typography } from "@mui/material";
import { useCallback, useMemo, useRef } from "react";
import { PatientSubscription } from "src/api/types";
import WhiteCard from "src/shared/components/WhiteCard";
import { useTranslation } from "react-i18next";

interface MedRemindersCardProps {
  subscription: PatientSubscription;
  page: string;
}

const MedRemindersCard = ({ subscription, page }: MedRemindersCardProps) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const { t } = useTranslation();
  const component = "medRemindersCard";

  const eventName = useMemo(
    () => t(`${page}.${component}.eventName`),
    [page, t],
  );

  const handleAddToCalendar = useCallback(async () => {
    if (buttonRef.current) {
      const { atcb_action } = await import("add-to-calendar-button-react");

      atcb_action(
        {
          name: eventName,
          description: "",
          startDate: subscription.current_period_end?.split("T")[0] || "",
          endDate: subscription.current_period_end?.split("T")[0] || "",
          options: ["Apple", "Google", "Microsoft365"],
          timeZone: "currentBrowser",
          hideBackground: true,
          hideCheckmark: true,
          listStyle: "overlay",
        },
        buttonRef.current,
      );
    }
  }, [eventName, subscription?.current_period_end]);

  return (
    <WhiteCard sx={{ cursor: "pointer" }} flexGrow={1}>
      <Stack direction="row" alignItems="center" gap={2}>
        <IconButton
          ref={buttonRef}
          size="medium"
          sx={{ color: "#000000" }}
          onClick={handleAddToCalendar}
        >
          <Notifications />
        </IconButton>
        <Stack gap={1}>
          <Typography fontWeight={600}>
            {t(`${page}.${component}.title`)}
          </Typography>
          <Typography>{t(`${page}.${component}.on`)}</Typography>
        </Stack>
      </Stack>
    </WhiteCard>
  );
};

export default MedRemindersCard;
